export default __webpack_public_path__ + "static/media/Thug's Mask of Waning Dusk.58ad8266.jpg";